import { useState } from "react";
import { Link } from "react-router-dom";
import JsonLd from "@/components/base/JsonLd";
import SectionHeading from "@/components/base/SectionHeading";
import { faqList } from "@/mocks/site";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqList.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20" aria-label="常见问题">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <SectionHeading
              kicker="投稿之前"
              title="你可能想问的几件事"
              desc="关于匿名、审核和评论区规则，这里都写清楚了。还有疑问可以走私信通道问我们。"
            />
            <div className="mt-6 rounded-lg border border-secondary-200 bg-secondary-50 p-5">
              <p className="text-sm leading-relaxed text-secondary-900">
                我们不会公开你的真实身份，也不会把联系方式展示给其他访客。
              </p>
              <Link
                to="/submit"
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap font-label text-sm text-primary-700 transition-colors hover:text-primary-800"
              >
                直接去投稿
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="divide-y divide-background-200 border-y border-background-200">
              {faqList.map((item, index) => {
                const open = openIndex === index;
                return (
                  <div key={item.q}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(open ? null : index)}
                        aria-expanded={open}
                        className="flex w-full items-center justify-between gap-4 py-5 text-left"
                      >
                        <span className="text-base font-semibold text-foreground-950 md:text-lg">{item.q}</span>
                        <span
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                            open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                          }`}
                        >
                          <i className={open ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
                        </span>
                      </button>
                    </h3>
                    {open ? (
                      <p className="pb-5 pr-12 text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <JsonLd data={schema} />
    </section>
  );
}